export const HOME_ROUTE = "/";
export const ABOUT_ROUTE = "/about";
export const CONTACT_ROUTE = "/contact";
export const ADMISSION_ROUTE = "/admission";
export const CALENDAR_ROUTE = "/calendar";
export const FACULTY_ROUTE = "/faculity";
export const PRIVACY_POLICY_ROUTE = "/privacy";
export const TERMS_ROUTE = "/terms";
export const SITEMAP_ROUTE = "/sitemap.xml";
export const TRANSPORT_ROUTE_ROUTE = "/transport-routes";
